var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangleExclamation = function SvgTriangleExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.085 19.2-.687 1.2h19.204l-.686-1.2-8.228-14.392-.69-1.208-.69 1.208zm16.447 0H4.465l7.533-13.181zm-8.134-4.8v.6h1.2V9.6h-1.2zm1.5 3.6v-1.8h-1.8V18z"
  })));
};
export default SvgTriangleExclamation;